module.exports = __webpack_public_path__ + "static/media/icon-heart-white.a6bcdc2c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon-heart-white.svg
// module id = 1460
// module chunks = 0